export var TypeActionSetPlayerName;
(function (TypeActionSetPlayerName) {
    TypeActionSetPlayerName["ChangePlayerName"] = "SetPlayerName > Change";
})(TypeActionSetPlayerName || (TypeActionSetPlayerName = {}));
export var actionSetPlayerName = function (username) { return ({
    type: TypeActionSetPlayerName.ChangePlayerName,
    username: username,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/set-player-name/actionSetPlayerName.ts
// module id = 891
// module chunks = 3